import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { InputOTP, InputOTPGroup, InputOTPSlot } from '@/components/ui/input-otp'
import { SubmitButton } from '@/components/ui/submit-button'
import { isProduction } from '../../config/config'
import { ChatActionWithValue, fetchSandboxDot } from '../../models/insuranceApplication'

interface ChatOtpProps {
  length?: number
  prefix?: string
  handleSubmit: (data: ChatActionWithValue | FormData) => void
  readonly?: boolean
}

export function ChatOtp({ length = 6, prefix, handleSubmit, readonly }: ChatOtpProps) {
  const [value, setValue] = useState('')
  const [loadingTestNumber, setLoadingTestNumber] = useState(false)

  function onSubmit() {
    handleSubmit({
      content: {
        component: 'P',
        content: `${prefix}-${value}`,
      },
      value: value,
    })
  }

  return (
    <form
      className="max-w-m4 mt-2"
      onSubmit={(event) => {
        event.preventDefault()
        if (!readonly && value) onSubmit()
      }}
    >
      <div className="mb-2 flex items-center justify-center gap-2">
        {prefix && <div className="text-md font-semibold text-black">{prefix} -</div>}
        <InputOTP
          maxLength={length}
          value={value}
          onChange={(value) => setValue(value)}
          autoComplete="off"
          disabled={readonly}
        >
          <InputOTPGroup>
            {[...Array(length ?? 6)].map((_, idx) => (
              <InputOTPSlot key={idx} index={idx} />
            ))}
          </InputOTPGroup>
        </InputOTP>
      </div>

      <div className="mt-6 flex items-center justify-end gap-2">
        {!isProduction && (
          <Button type="button" onClick={() => setValue('3300318')} variant="outline" disabled={readonly}>
            CT number
          </Button>
        )}

        {!isProduction && (
          <Button
            type="button"
            onClick={async () => {
              setLoadingTestNumber(true)
              try {
                const dot = await fetchSandboxDot()
                setValue(String(dot))
              } finally {
                setLoadingTestNumber(false)
              }
            }}
            variant="outline"
            disabled={readonly}
            loading={loadingTestNumber ? 'Loading…' : undefined}
          >
            Test number
          </Button>
        )}

        <SubmitButton disabled={readonly || !value} />
      </div>
    </form>
  )
}
